import Swal from 'sweetalert2';

import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AvantoSessionService } from './services/avanto-session.service';
import { AvantoUserAuthService } from './services/avanto-user-auth.service';
import { AvantoCustomerService } from './services/avanto-customer-info.service';
import { AvantoRoutingService } from './services/avanto-routing.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {

  isSessionLoaded: boolean;
  numberOfTries: number;

  constructor(
    private avantoSession: AvantoSessionService, 
    private customerService: AvantoCustomerService, 
    private auth: AvantoUserAuthService, 
    private angularRouter: Router, 
    private avantoRoute: AvantoRoutingService,
    private location: Location
  ) { }

  ngOnInit() {
    this.numberOfTries = 0;//If I can't get the session, I will retry to do it a couple of times. This variable controls that.
    this.isSessionLoaded = false;//Initialization
    if(this.location.path() == ''){
      window.location.replace("/website/");
    }else{
      this.initSession();
    }
  }

  /** Initializes the user session. 
   * Creates a new session object on the database, if it doesnt exist yet, or fetches it if it does.
   * We try to initialize the session 3 times.
   */
  initSession() {
    this.avantoSession.getSession().then(
      async (retrievedSession) => {
        //Checks if the user is logged in. If so, saves his relevant info on the session.
        try {
          //Checking if the customer is logged in. If not, the code will take you to "CATCH" down below
          const customerInfo = await this.auth.getCustomerInfo();

          //--- IF THE CUSTOMER IS LOGGED IN:
          //If the session doesn't have the customer address on it (new session), we see if the logged in customer (if he is logged in)
          //has this information saved on the database
          if (!retrievedSession.customerAddress.isAddressSet()) {
            try {
              const retrievedCustomerInfo = await this.customerService.getCustomer(customerInfo.id)
              const lastAddressUsed = retrievedCustomerInfo.customer.lastAddressUsed;
              //The customer has an address that we can use!
              if (lastAddressUsed != null && lastAddressUsed.isAddressSet()) {
                retrievedSession = await this.avantoSession.setCustomerAddress(lastAddressUsed.address, lastAddressUsed.lat, lastAddressUsed.lng, lastAddressUsed.additionalNotes)
              }
            } catch (ex) {
              console.log("Could not save the customer's last used address on the session", ex)
            }
          }
        } catch (err) {
          console.log("No user currently logged in")
        }


        
        //================================= ONE RESTAURANT MODE ======================================
        const restaurantId = this.angularRouter.url.replace("/menu/", "").replace("/", ".") //==> Gets the restaurant id from the URL
        //If we are at the /menu page and either we are not on the "one restaurant mode" or we are, but the selected 
        //restaurant is different from the one we have saved on the session...
        if (this.angularRouter.url.startsWith("/menu") &&
        (!retrievedSession.isOneRestaurantMode || retrievedSession.restaurantInformation.restaurantId != restaurantId)) {
          //TODO: if restaurant is different, clear the cart!
          console.log("=== SWITCHING TO ONE RESTAURANT MODE ===")
          this.avantoSession.updateOneRestaurantModeInfo(true, restaurantId).finally(()=>{
            this.isSessionLoaded = true;
          })
        } else if ((this.angularRouter.url == "/" || this.angularRouter.url == "/choose-restaurant" || this.angularRouter.url.startsWith("/restaurant")) &&
        retrievedSession.isOneRestaurantMode) {
          console.log("=== EXITING ONE RESTAURANT MODE ===")
          this.avantoSession.updateOneRestaurantModeInfo(false).finally(()=>{
            this.isSessionLoaded = true;
          })
          //================================= ONE RESTAURANT MODE END ======================================
        }else{
          this.isSessionLoaded = true;
        }

        //If the user has an address set for him already, there is no need to get it again. 
        //We then redirect to the choose restaurant page
        if (this.angularRouter.url == "/" && retrievedSession.customerAddress.isAddressSet()) {
          this.avantoRoute.goToChooseRestaurantPage();
        }
      })
      .catch(() => {
        //If I fail to get the session, try again until I succeed
        setTimeout(() => {
          if (this.numberOfTries < 3) {
            this.initSession();
            this.numberOfTries++;
          } else {
            Swal.fire("Could not establish connection to server", "Please try refreshing the page", "error")
          }
        }, 3000);
      });
  }
}